import clsx from "clsx";

import { Subtitle } from "..";
import styles from "./product-card.module.css";

export const ProductLabelTags = ({
  labels,
  className,
}: {
  labels?: string[];
  className?: string;
}) => {
  if (!labels?.length) return null;

  return (
    <>
      {labels.map(label => (
        <div
          key={label}
          className={clsx(styles.card__tag, styles["black-tag"], className)}
        >
          <Subtitle noBrackets>{label}</Subtitle>
        </div>
      ))}
    </>
  );
};
